export default __webpack_public_path__ + "static/media/plus_icon.eb6628de.svg";